<template>
    <div class="edu-course-area course-area-3 section-gap-large bg-lighten04">
        <div class="container">
            <SectionTitle preTitle="組織架構" title='樂團成員' alignment='section-center' />
            
            <div class="isotope-wrapper">

                <div class="isotop-button isotop-filter nav">
                    <button class="nav-link" data-bs-toggle="pill" data-bs-target="#undergraduate" role="tab" @click="filterDataType1('理事會')">理事會</button>
                </div>
                <div class="isotop-button isotop-filter nav">
                    <button class="nav-link" data-bs-toggle="pill" data-bs-target="#undergraduate" role="tab" @click="filterDataType1('指揮')">指揮</button>
                </div>
                <div class="isotop-button isotop-filter nav">
                    <button class="nav-link" data-bs-toggle="pill" data-bs-target="#graduate" role="tab" @click="filterDataType1('吹管')">吹管</button>
                    <button class="nav-link" data-bs-toggle="pill" data-bs-target="#undergraduate" role="tab" @click="filterDataType1('彈撥')">彈撥</button>
                    <button class="nav-link" data-bs-toggle="pill" data-bs-target="#online" role="tab" @click="filterDataType1('拉弦')">拉弦</button><br>   
                    <button class="nav-link" data-bs-toggle="pill" data-bs-target="#online" role="tab" @click="filterDataType1('敲擊')">敲擊</button> 
                    <button class="nav-link" data-bs-toggle="pill" data-bs-target="#undergraduate" role="tab" @click="filterDataType1('其他')">其他</button>
                </div>
                <div
                    v-for="record in filteredData"
                    :key="record.id"
                    class="record-box"
                    @click="showDetails(record)"
                    :class="{
                        '指揮-background': record.Type2 === '指揮',
                        '笛子-background': record.Type2 === '笛子',
                        '笙-background': record.Type2 === '笙',
                        '嗩吶-background': record.Type2 === '嗩吶',
                        '洞簫-background': record.Type2 === '洞簫',
                        '古箏-background': record.Type2 === '古箏',
                        '揚琴-background': record.Type2 === '揚琴',
                        '中阮-background': record.Type2 === '中阮',
                        '琵琶-background': record.Type2 === '琵琶',
                        '柳琴-background': record.Type2 === '柳琴',
                        '電阮-background': record.Type2 === '電阮',
                        '結他-background': record.Type2 === '結他',
                        '高胡-background': record.Type2 === '高胡',
                        '二胡-background': record.Type2 === '二胡',
                        '中胡-background': record.Type2 === '中胡',
                        '板胡-background': record.Type2 === '板胡',
                        '大提琴-background': record.Type2 === '大提琴',
                        '敲擊-background': record.Type2 === '敲擊',
                        '歌詠-background': record.Type2 === '歌詠',
                        '司儀-background': record.Type2 === '司儀',
                        '普通團員-background': record.Type2 === '普通團員',
                        'peru-background': record.Type2 !== '指揮' && record.Type2 !== '笛子' && record.Type2 !== '笙' 
                            && record.Type2 !== '古箏' && record.Type2 !== '揚琴' && record.Type2 !== '中阮' 
                            && record.Type2 !== '琵琶' && record.Type2 !== '柳琴' && record.Type2 !== '二胡' 
                            && record.Type2 !== '中胡' && record.Type2 !== '大提琴' && record.Type2 !== '敲擊'
                            && record.Type2 !== '歌詠' && record.Type2 !== '司儀' && record.Type2 !== '普通團員'
                            && record.Type2 !== '嗩吶' && record.Type2 !== '洞簫' && record.Type2 !== '電阮'
                            && record.Type2 !== '高胡' && record.Type2 !== '板胡' && record.Type2 !== '結他' 
                    }"
                >
                    {{ record.中文姓名 }} [{{ record.Type2 }}]
                </div>

                <ModalPopup v-if="isModalVisible" :record="modalData" @close="isModalVisible = false"></ModalPopup>

            </div>
        </div>

        <ul class="shape-group">
            <li class="shape-1">
                <img src="/images/others/map-shape-3.png" alt="Shape">
            </li>
            <li class="shape-2">
                <img src="/images/others/map-shape-3.png" alt="Shape">
            </li>
        </ul>

    </div>
</template>

<script>

    import AOS from 'aos'
    import 'aos/dist/aos.css'

    import { Swiper, SwiperSlide } from "vue-awesome-swiper";
    import 'swiper/css/swiper.css'    

    import ModalPopup from '@/components/hkcco/ModalPopup';

    export default {

        components: {
            Swiper,
            SwiperSlide,
            ModalPopup,
            SectionTitle: () => import('@/components/common/SectionTitle'),
        },

        mounted() {
            AOS.init();
            this.fetchData();
        },   

        data () {
            return {
                swiperOptions: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    pagination: false,
                    grabCursor: true,
                    speed: 1500,
                    autoplay: {
                        delay: 1500
                    },
                    breakpoints: {
                        577: {
                            slidesPerView: 2
                        }
                    }
                },
                records: [],
                selectedType: 'ALL',
                filteredData: [],
                isModalVisible: false,
                modalData: {}
            }
        },

        methods: {
            fetchData() {
                fetch('/data/data.json')
                    .then(response => response.json())
                    .then(data => {
                        //console.log('Loaded JSON data:', data)
                        this.records = data;
                        this.filterData();
                    })
                    .catch(error => console.error('Error loading JSON data:', error));
            },

            filterData() {
                this.filteredData = this.selectedType === 'ALL'
                    ? this.records
                    : this.records.filter(record => record.Type2 === this.selectedType);
            },

            showDetails(record) {
                this.modalData = record;
                this.isModalVisible = true;
            },

            filterDataType1(Type1) {
                console.log(Type1)
                this.filteredData = this.records.filter(record => record.Type1 === Type1);
                console.log(this.records.filter(record => record.Type1 === Type1))
            },

        }


    }
</script>

<style lang="scss">
    .course-area-3 {
        .isotop-button {
            button {
                &:hover,
                &.active {
                    background-color: var(--color-secondary);
                    color: var(--color-white);
                }
                &.active:after {
                    bottom: -10px;
                    visibility: visible;
                    opacity: 1;
                }
            }
        }
    }

    .dark-mode {
        .course-area-3 { 
            .isotop-button {
                button {
                    &:hover,
                    &.active {
                        background-color: var(--color-secondary);
                        color: var(--color-white);
                    }
                }
            }
        }
    }

    .record-box {
        display: inline-block;
        background-color: blue;
        color: white;
        padding: 3px;
        border-radius: 15px;
        margin: 5px;
        cursor: pointer;
        width: 150px;
    }
    .record-box:hover {
        background-color: darkblue;
    }

    .指揮-background {
        background-color: #EC5945;
        text-align: center;
        //color: black;
    }
    .笛子-background {
        background-color: #71C413; 
        text-align: center;
        //color: black;
    }
    .笙-background {
        background-color: #71C413;
        text-align: center;
        //color: black;
    }
    .嗩吶-background {
        background-color: #71C413;
        text-align: center;
        //color: black;
    }
    .洞簫-background {
        background-color: #71C413;
        text-align: center;
        //color: black;
    }
    .古箏-background {
        background-color: #FF4B73;
        text-align: center;
        //color: black;
    }
    .揚琴-background {
        background-color: #FF4B73;
        text-align: center;
        //color: black;
    }
    .中阮-background {
        background-color: #FF4B73;
        text-align: center;
        //color: black;
    }
    .琵琶-background {
        background-color: #FF4B73;
        text-align: center;
        //color: black;
    }
    .柳琴-background {
        background-color: #FF4B73;
        text-align: center;
        //color: black;
    }
    .電阮-background {
        background-color: #FF4B73;
        text-align: center;
        //color: black;
    }
    .結他-background {
        background-color: #FF4B73;
        text-align: center;
        //color: black;
    }
    .高胡-background {
        background-color: #4B96FF;
        text-align: center;
        //color: black;
    }
    .二胡-background {
        background-color: #4B96FF;
        text-align: center;
        //color: black;
    }
    .中胡-background {
        background-color: #4B96FF;
        text-align: center;
        //color: black;
    }
    .板胡-background {
        background-color: #4B96FF;
        text-align: center;
        //color: black;
    }
    .大提琴-background {
        background-color: #4B96FF;
        text-align: center;
        //color: black;
    }
    .敲擊-background {
        background-color: #E69C11;
        text-align: center;
        //color: black;
    }
    .歌詠-background {
        background-color: #1C9F71;
        text-align: center;
        //color: black;
    }
    .司儀-background {
        background-color: #1C9F71;
        text-align: center;
        //color: black;
    }
    .普通團員-background {
        background-color: #1C9F71;
        text-align: center;
        //color: black;
    }
    .peru-background {
        background-color: #7D49F9;
        text-align: center;
        //color: black;
    }

</style>